@file:OptIn(InternalResourceApi::class)

package com.github.joao_fernandes_fra.pzzle.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/com.github.joao_fernandes_fra.pzzle.generated.resources/"

internal val Res.font.BlackHanSans_Regular: FontResource by lazy {
      FontResource("font:BlackHanSans_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/BlackHanSans-Regular.ttf", -1, -1),
      ))
    }

internal val Res.font.ShareTechMono_Regular: FontResource by lazy {
      FontResource("font:ShareTechMono_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/ShareTechMono-Regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("BlackHanSans_Regular", Res.font.BlackHanSans_Regular)
  map.put("ShareTechMono_Regular", Res.font.ShareTechMono_Regular)
}
